import React from 'react';
import styled, { css } from 'react-emotion';

import Button from '@material-ui/core/Button';

import { setTitle } from '../../utils/title';
import background from '../../assets/images/500-background.svg';
import logo from '../../assets/images/unlimited-financials-horz-logo-2-color.svg';

const Wrapper = styled('div')`
   width: 100vw;
   height: 100vh;
   display: flex;
   flex-direction: column;
   align-items: center;
   background: url(${background}) no-repeat center center fixed;
   background-size: cover;
`;

const LogoContainer = styled('div')`
   flex: 0 0 25%;
   display: flex;
   width: 100%;
   max-width: 498px;
   min-width: 320px;
   min-height: 142px;
   padding: 24px;
`;

const Logo = styled('img')`
   width: 100%;
   height: 100%;
   padding: 24px;
`;

const Ribbon = styled('div')`
   flex: 0 0 auto;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   width: 100%;
   background-color: rgba(255, 255, 255, 0.5);
   padding: 24px;
`;

const Title = styled('h1')`
   ${props => css`
      ${props.theme.text.styles.heading2};
      text-transform: uppercase;
      margin-bottom: 12px;
   `};
`;

const Content = styled('div')`
   ${props => css`
      ${props.theme.text.styles.body2};
      max-width: 498px;
      width: 100%;
      margin-bottom: 24px;
   `};
`;

export const UncaughtException = () => {
   setTitle('500 Error');
   return (
      <Wrapper>
         <LogoContainer>
            <Logo src={logo} />
         </LogoContainer>
         <Ribbon>
            <Title>500 Error</Title>
            <Content>
               Sorry, our system experienced a technical error. Please wait a few moments and try
               again. If you continue to get this error message, contact support.
            </Content>
            <Button
               variant="raised"
               color="primary"
               onClick={() => (window.location.href = window.location.origin)}
            >
               Go Home
            </Button>
         </Ribbon>
      </Wrapper>
   );
};

export default UncaughtException;



// WEBPACK FOOTER //
// ./src/ErrorBoundary/components/UncaughtException.js